import { render, staticRenderFns } from "./NButtonRestore.vue?vue&type=template&id=78e8d994&scoped=true&"
import script from "./NButtonRestore.vue?vue&type=script&lang=js&"
export * from "./NButtonRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e8d994",
  null
  
)

export default component.exports